module.exports = __webpack_public_path__ + "media/print/flashcard-styles_back-to-back-3764283a.png";